import { useGetProjectScansWithOutputsOnlyQuery } from "api/project/queries/useGetProjectScansWithOutputsOnlyQuery";
import { useState, useMemo, useEffect, useCallback } from "react";
import { useSearchParams, useParams, useLocation } from "react-router-dom";
import { ScanDetails } from "types/scan";

interface SearchParams {
  type: "vtour" | "ptcld";
  mode: "uniscan" | "uniscan-compare" | "biscan";
}

const useViewerWrapper = (
  scans: OutputsOnlyQueryType | undefined,
  setPage: React.Dispatch<
    React.SetStateAction<{ page: number | undefined; earlierPage: number | undefined }>
  >
) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [scan, setScan] = useState<ScanDetails>();

  const scansLength = useMemo(() => {
    return scans?.items?.length || 0;
  }, [scans]);

  useEffect(() => {
    console.log("scans useWrapper", scans);
    if (scans && scansLength > 0) {
      setCurrentIndex(scans?.currentIndex);
    }
  }, [scans]);

  useEffect(() => {
    console.log("currentIndex", currentIndex);
    if (scans && scansLength > 0 && currentIndex < scansLength && currentIndex >= 0) {
        setScan(scans.items[currentIndex]);
    }
  }, [currentIndex, scans]);

  const dateText = useMemo(
    () =>
      new Date(scan?.scanDate || scan?.createdAt || "").toLocaleString("en", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }),
    [scan]
  );

  const ptcldOutputId = useMemo(() => {
    return (
      scan?.outputs?.find((output) => output.type === "POINTCLOUD")?.id || ""
    );
  }, [scan]);
  const vtourOutputId = useMemo(() => {
    return (
      scan?.outputs?.find((output) => output.type === "VIRTUALTOUR")?.id || ""
    );
  }, [scan]);
  const gsplatOutputId = useMemo(() => {
    return (
      scan?.outputs?.find((output) => output.type === "GAUSSIANSPLATS")?.id || ""
    );
  }, [scan]);

  const hasNext = useMemo(() => {
    return (
      (scans && scans?.page < Math.ceil(scans?.total / scans?.perPage)) ||
      currentIndex + 1 < scansLength
    );
  }, [scans, currentIndex]);

  const hasPrev = useMemo(() => {
    return (scans && scans?.page - 1 > 0) || currentIndex - 1 >= 0;
  }, [scans, currentIndex]);

  const handlePrevScan = useCallback(() => {
    if (currentIndex - 1 >= 0) {
      setCurrentIndex((prev) => {
        return prev - 1;
      });
    } else {
      if (scans && scans.page > 1) {
        setPage(() => {
          return {
            page: scans.page - 1,
            earlierPage: scans.page,
          };
        });
      }
    }
  }, [scans, currentIndex]);

  const handleNextScan = useCallback(() => {
    console.log("scansLength", scansLength);
    if (currentIndex + 1 < scansLength) {
      setCurrentIndex((prev) => {
        return prev + 1;
      });
    } else {
      if (scans && scans.page + 1 <= Math.ceil(scans.total / scans.perPage)) {
        setPage(() => {
          return {
            page: scans.page + 1,
            earlierPage: scans.page,
          };
        });
      }
    }
  }, [scans, currentIndex, scansLength]);

  return {
    scan,
    dateText,
    ptcldOutputId,
    vtourOutputId,
    gsplatOutputId,
    scanId: scan?.id || "",
    handleNextScan,
    handlePrevScan,
    hasNext,
    hasPrev,
  };
};

export default useViewerWrapper;
